import Crud from "./Crud";
import Endpoints from "../constants/Endpoints";

export default Crud(Endpoints.projectGroups, '1')
